import Config from "../../config/Config";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getAllInvoice = (
  size,
  page,
  sort,
  by,
  dir,
  status,
  tags = [],
  callerIds = [],
  title = "",
) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      sort: `${sort},${by}`,
      page: String(page),
      size: String(size),
    });

    if (tags.length > 0) {
      params.append("tags", tags.join(","));
    }

    if (callerIds.length > 0) {
      params.append("callerIds", callerIds.join(","));
    }

    if (title) {
      params.append("title", title);
    }

    axios
      .get(`${baseUrlDev}katalis/invoice/unpaid?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDetailInvoiceHistory = (invoiceId, transactionId) => {
  // katalis/invoice/{invoiceId}/history/{transactionId}/calculate-amount
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}katalis/invoice/${invoiceId}/history/${transactionId}/calculate-amount`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        },
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllInvoiceHistory = (size, page, sort, dir, status) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}katalis/invoice/history?sort=paymentDate,${sort}&skip=${page}&limit=${size}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        },
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceTags = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}katalis/invoice/tags`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllInvoicePaid = (size, page, sort, dir, status) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}katalis/invoice/paid?sort=history.dateTime,${sort}&page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        },
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllInvoiceSummary = (size, page, sort, dir, status) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}katalis/invoice/all?callerId=&sort=invoiceDate,${sort}&page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${bearer()}`,
          },
        },
      )
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDetailInvoice = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}mob_user/invoice_rework/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const invoicePayment = (data) => {
  post = "";
  var post;
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}katalis/transaction/invoice/payment`, data, {
        headers: { Authorization: `Bearer ${bearer()}` },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const downloadSummary = () => {
  let url = `${baseUrlDev}katalis/invoice/all/download?status=&fromDate=&toDate=`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceDetail = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}katalis/invoice/${id.id}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getInvoiceFeature = (id = { id: "686f5687b724f1d9acfc1511" }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}auth-support/feature/${id.id}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
